import { render, staticRenderFns } from "./SubComponent.vue?vue&type=template&id=3b3e9c20&"
import script from "./SubComponent.vue?vue&type=script&lang=js&"
export * from "./SubComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports